import { gql, useQuery } from 'urql';
import { Form } from '@entities/leadCollector';

export const EVENT_QUERY = gql`
  query GetEventById($id: Int!) {
    getEventById(eventId: $id) {
      id
      name
      description
      confirmed
      active
      image
      dateStart
      dateEnd
      createdAt
      updatedAt
      groups {
        name
      }
      formId
      hasGeneratedLinks
      settings {
        showFioInApp
      }
      ticketsMetadata {
        activeCount
        checkedCount
        total
        countAdultGuests
        countAdultWithChildGuests
        countChildGuests
      }
      metadata {
        isPendingTickets
        isPendingInvites
        totalInvites
        countAcceptedInvites
        countDeclinedInvites
        ticketsSent
      }
      formData {
        id
        name
        bodyForm
        status
        maxExtraChildren
        maxExtraAdults
        createdAt
        updatedAt
      }
      formLinks {
        linkToken
        status
      }
    }
  }
`;

export interface IEventParticipant {
  id: number;
  uuid: string;
  email: string;
  login: string;
  position: string;
  phone: string;
  firstName: string;
  lastName: string;
  avatar: string;
  confirmed: boolean;
  departamentUuid: string;
  createdAt: string;
  updatedAt: string;
}

export interface EventTicketsBlock {
  activeCount: number;
  checkedCount: number;
  total: number;
  countAdultGuests: number;
  countAdultWithChildGuests: number;
  countChildGuests: number;
}

export interface EventMetadata {
  isPendingTickets: boolean;
  isPendingInvites: boolean;
  totalInvites: number;
  countAcceptedInvites: number;
  countDeclinedInvites: number;
  ticketsSent: number;
}

export interface IEventSettings {
  showFioInApp: boolean;
}

export interface EventGroup {
  name: string;
}

export interface FormLink {
  linkToken: string;
  status: string;
}

export interface IEvent {
  id: number;
  name: string;
  description: string;
  confirmed: string;
  active: boolean;
  image: string;
  dateStart: string;
  dateEnd: string;
  groups: EventGroup[];
  formId: number | null;
  hasGeneratedLinks: boolean;
  formData: Form;
  formLinks?: FormLink[] | null;
  settings: IEventSettings;
  ticketsMetadata: EventTicketsBlock;
  metadata?: EventMetadata | null;
}

export interface IEventResponse {
  getEventById: IEvent;
}

export const useFetchEvent = (id: number) => {
  const [{ error, fetching, data: event }, reexecuteQuery] = useQuery<IEventResponse>({
    query: EVENT_QUERY,
    variables: { id },
    pause: !id,
    requestPolicy: 'network-only',
  });
  return { error, event, fetching, refetch: reexecuteQuery };
};
